export const EDIT = 'EDIT'
export const ADD = 'ADD'
export const ADD_GOV_AGENCY = 'ADD_GOV_AGENCY'
export const ADD_INSTITUTION = 'ADD_INSTITUTION'
export const READ = 'READ'
